<template>
  <div>
    <nav class="container mx-auto py-5">
      <div class="flex justify-between">
        <Brand></Brand>
        <div class="hidden md:block space-x-4 py-2 pr-5 uppercase">
          <NavLink href="/admin" :active="$page.component === 'Admin/Dashboard'">Admin Home</NavLink>
          <NavLink href="/admin/invitations" :active="$page.component === 'Admin/Invitations'">Invitations</NavLink>
          <NavLink href="/admin/reminders" :active="$page.component === 'Admin/Reminders'">Reminders</NavLink>
          <NavLink href="/admin/reviews" :active="$page.component === 'Admin/Reviews' || $page.component === 'Admin/ViewReview'">
			Reviews
		  </NavLink>
          <template v-if="user === null">
            <NavLink v-if="user === null" href="/login" :active="$page.component === 'Login'">Login</NavLink>
          </template>
          <template v-else>
            <form class="inline-block" @submit.prevent="logoutForm.post('/logout')" autocomplete="off">
              <button class="uppercase" type="submit">Logout</button>
            </form>
          </template>
        </div>
        <div class="md:hidden pr-5 py-2">
          <svg v-on:click="this.onClickHamburger" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none"
            viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </div>
      </div>
    </nav>
    <div class="mx-auto">
      <div class="flex-nowrap">
        <div class="absolute w-full">
          <div v-if="showMenu" class="relative w-full md:hidden bg-white shadow z-50 opacity-80">
            <ul>
              <NavLink href="/admin" :active="$page.component === 'Admin/Dashboard'" class="">
                <li class="w-full hover:bg-brand-blue-100 pl-5 p-3">Admin Home</li>
              </NavLink>
              <NavLink href="/admin/invitations" :active="$page.component === 'Admin/Invitations'">
                <li class="w-full hover:bg-brand-blue-100 pl-5 p-3">Invitations</li>
              </NavLink>
              <NavLink href="/admin/reminders" :active="$page.component === 'Admin/Reminders'">
                <li class="w-full hover:bg-brand-blue-100 pl-5 p-3">Reminders</li>
              </NavLink>
              <NavLink href="/admin/reviews" :active="$page.component === 'Admin/Reviews' || $page.component === 'Admin/ViewReview'">
                <li class="w-full hover:bg-brand-blue-100 pl-5 p-3">Reviews</li>
              </NavLink>
              <template v-if="user === null">
                <NavLink href="/login" :active="$page.component === 'Login'">
                  <li class="w-full hover:bg-brand-blue-100 pl-5 p-3">Login</li>
                </NavLink>
              </template>
              <template v-else>
                <form @submit.prevent="logoutForm.post('/logout')" autocomplete="off">
                  <button class="w-full hover:bg-brand-blue-100 pl-5 p-3 text-left" type="submit">
                    Logout
                  </button>
                </form>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavLink from "@/Shared/NavLink.vue";
import Brand from "@/Shared/Brand.vue";
import { useForm } from "@inertiajs/inertia-vue3";

export default {
  components: {
    NavLink,
    Brand,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    onClickHamburger() {
      this.showMenu = !this.showMenu;
    },
  },
  props: {
    user: {
      default: null,
      required: false,
      type: Object,
    },
  },
  setup() {
    const logoutForm = useForm({});

    return {
      logoutForm,
    };
  },
};
</script>
